<template>
  <div v-if="cart.cartLoading">
    <loading-component></loading-component>
  </div>
  <div v-else-if="cart.numberOfItems < 1" class="alert alert-info clearfix">
    <div id="empty-cart-notice" class="pull-left">Your cart is empty.</div>
    <div class="pull-right">
      <a href="/shop" title="View Products" class="btn btn-primary">
        Let's change that
      </a>
    </div>
  </div>
  <div v-else id="component-cart" class="row">
    <div class="col-md-9 cart-main">
      <div class="panel panel-default">
        <mobile-item-panel></mobile-item-panel>
        <item-table></item-table>
        <div class="panel-footer">
          <div class="navbar-collapse">
            <ul class="nav navbar-right hidden-xs">
              <li>
                <p>
                  <a
                    class="btn btn-primary"
                    href="/shop"
                    title="Continue Shopping"
                    role="button"
                  >
                    Continue Shopping
                  </a>
                </p>
              </li>
            </ul>
            <ul class="nav navbar-right hidden-lg hidden-md hidden-sm">
              <li>
                <p>
                  <a
                    class="btn btn-primary"
                    href="/shop"
                    title="Continue Shopping"
                    role="button"
                  >
                    Continue Shopping
                  </a>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <cart-details></cart-details>
  </div>
</template>

<script>
import { mapState } from "vuex";
import store from "../../store/stores";
import ItemTable from "./ItemTable.vue";
import MobileItemPanel from "./MobileItemPanel.vue";
import CartDetails from "./CartDetails.vue";
import LoadingComponent from "../checkout/components/elements/LoadingComponent.vue";

export default {
  name: "Cart",
  store,
  components: { ItemTable, MobileItemPanel, CartDetails, LoadingComponent },
  computed: {
    ...mapState(["cart"]),
  },
  created() {
    this.$store.dispatch("cart/getCartItems");
  },
};
</script>

<style scoped>
#empty-cart-notice {
  margin: 10px;
}
</style>
